import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  answerQuestionRequested,
  askQuestionRequested,
  cancelLiveAnswerRequested,
  deleteAnswerRequested,
  deleteQuestionRequested,
  dismissQuestionRequested,
  editAnswerRequested,
  editQuestionRequested,
  questionAnswerTypeResetRequested,
  removeUpvoteQuestionRequested,
  reopenQuestionRequested,
  signalingAnswerDeleted,
  signalingAnswerEdited,
  signalingQuestionAnswered,
  signalingQuestionAsked,
  signalingQuestionDeleted,
  signalingQuestionEdited,
  signalingQuestionLiveAnswerCancelled,
  signalingQuestionLiveAnswerStarted,
  signalingQuestionLiveAnswerStopped,
  startLiveAnswerRequested,
  stopLiveAnswerRequested,
  upvoteQuestionRequested,
} from 'features/qa/actions';
import { askQuestionSaga } from 'features/qa/sagas/askQuestionSaga';
import { resetQuestionAnswerSaga } from 'features/qa/sagas/resetQuestionAnswerSaga';
import { deleteQuestionSaga } from 'features/qa/sagas/deleteQuestionSaga';
import { deleteAnswerSaga } from 'features/qa/sagas/deleteAnswerSaga';
import { cancelLiveAnswerSaga } from 'features/qa/sagas/cancelLiveAnswerSaga';
import { startLiveAnswerSaga } from 'features/qa/sagas/startLiveAnswerSaga';
import { stopLiveAnswerSaga } from 'features/qa/sagas/stopLiveAnswerSaga';
import { onLiveAnswerStartedSaga } from 'features/qa/sagas/onLiveAnswerStartedSaga';
import { onLiveAnswerStoppedSaga } from 'features/qa/sagas/onLiveAnswerStoppedSaga';
import { onQuestionAskedSaga } from 'features/qa/sagas/onQuestionAskedSaga';
import { answerQuestionSaga } from 'features/qa/sagas/answerQuestionSaga';
import { onQuestionAnsweredSaga } from 'features/qa/sagas/onQuestionAnsweredSaga';
import { onQuestionDeletedSaga } from 'features/qa/sagas/onQuestionDeletedSaga';
import { editQuestionSaga } from 'features/qa/sagas/editQuestionSaga';
import { editAnswerSaga } from 'features/qa/sagas/editAnswerSaga';
import { onQuestionEditedSaga } from 'features/qa/sagas/onQuestionEditedSaga';
import { onAnswerEditedSaga } from 'features/qa/sagas/onAnswerEditedSaga';
import { onAnswerDeletedSaga } from 'features/qa/sagas/onAnswerDeletedSaga';
import { upvoteQuestionSaga } from 'features/qa/sagas/upvoteQuestionSaga';
import { removeUpvoteQuestionSaga } from 'features/qa/sagas/removeUpvoteQuestionSaga';
import { exportQuestionsSaga } from 'features/qa/sagas/exportQuestionsSaga';
import { exportQuestionsRequested } from 'features/qa/qaSlice';
import { dismissQuestionSaga } from 'features/qa/sagas/dismissQuestionSaga';
import { reopenQuestionSaga } from 'features/qa/sagas/reopenQuestionSaga';
import { onLiveAnswerCancelledSaga } from 'features/qa/sagas/onLiveAnswerCancelledSaga';

export default function* qaWatcher() {
  yield takeEvery(askQuestionRequested, askQuestionSaga);
  yield takeEvery(signalingQuestionAsked, onQuestionAskedSaga);

  yield takeEvery(upvoteQuestionRequested, upvoteQuestionSaga);
  yield takeEvery(removeUpvoteQuestionRequested, removeUpvoteQuestionSaga);

  yield takeEvery(answerQuestionRequested, answerQuestionSaga);
  yield takeEvery(questionAnswerTypeResetRequested, resetQuestionAnswerSaga);

  yield takeEvery(signalingQuestionAnswered, onQuestionAnsweredSaga);

  yield takeEvery(editQuestionRequested, editQuestionSaga);
  yield takeEvery(signalingQuestionEdited, onQuestionEditedSaga);
  yield takeEvery(editAnswerRequested, editAnswerSaga);
  yield takeEvery(signalingAnswerEdited, onAnswerEditedSaga);

  yield takeEvery(deleteQuestionRequested, deleteQuestionSaga);
  yield takeEvery(signalingQuestionDeleted, onQuestionDeletedSaga);

  yield takeEvery(deleteAnswerRequested, deleteAnswerSaga);
  yield takeEvery(signalingAnswerDeleted, onAnswerDeletedSaga);

  yield takeEvery(startLiveAnswerRequested, startLiveAnswerSaga);
  yield takeEvery(stopLiveAnswerRequested, stopLiveAnswerSaga);
  yield takeEvery(cancelLiveAnswerRequested, cancelLiveAnswerSaga);

  yield takeEvery(signalingQuestionLiveAnswerStarted, onLiveAnswerStartedSaga);
  yield takeEvery(signalingQuestionLiveAnswerCancelled, onLiveAnswerCancelledSaga);
  yield takeEvery(signalingQuestionLiveAnswerStopped, onLiveAnswerStoppedSaga);

  yield takeLatest(exportQuestionsRequested, exportQuestionsSaga);

  yield takeEvery(dismissQuestionRequested, dismissQuestionSaga);
  yield takeEvery(reopenQuestionRequested, reopenQuestionSaga);
}
